var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"productLayout"}},[_c('div',{attrs:{"id":"appClusterBar"}},[_c('cluster-bar',{attrs:{"instances":_vm.instances}})],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }